import React, { FC } from 'react';
import clsx from 'clsx';
import { makeStyles, List, ListItem, ListItemText, Theme, Typography } from '@material-ui/core';
import CandidatePageContents from 'typings/enum/CandidatePageContents';
import { PRIMARY_COLOR, GRAY_3 } from 'constants/colors';

const useStyles = makeStyles((theme: Theme) => ({
  listItem: {
    paddingLeft: theme.spacing(0),
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(0),
    paddingBottom: theme.spacing(1),
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  listItemText: {
    color: GRAY_3
  },
  listItemTextActive: {
    color: PRIMARY_COLOR,
    fontWeight: 500
  }
}));

interface Props {
  subMenuActive: CandidatePageContents;
  selectedRenderContent: (page: CandidatePageContents) => React.MouseEventHandler;
}

const SubMenu: FC<Props> = props => {
  const { selectedRenderContent, subMenuActive } = props;

  const subMenus = Object.values(CandidatePageContents);

  const classes = useStyles();

  return (
    <List>
      {subMenus.map((subMenu, index) => (
        <ListItem className={classes.listItem} button disableRipple onClick={selectedRenderContent(subMenu)} key={index}>
          <ListItemText
            primary={
              <Typography variant='body1' color='textSecondary' className={clsx(classes.listItemText, subMenuActive === subMenu && classes.listItemTextActive)}>
                {subMenu}
              </Typography>
            }
          />
        </ListItem>
      ))}
    </List>
  );
};

export default SubMenu;
